// Vendor
import accessibleAutocomplete from 'accessible-autocomplete'
import 'accessible-autocomplete/dist/accessible-autocomplete.min.css'
import '../stylesheets/wayfinder_autocomplete.scss'

Blacklight.onLoad(function() {

    var elementary_json;
    var middle_json;
    var highschool_json;
    var k12_json;
    var otherk12_json;
    var publiclib_json;
    var highered_json;

    $.getJSON('/wayfinder_data.json', function(data) {
        // TODO: remove 'elem' and 'midd' after galileo_admin:site_type feature flag is done
        if( data['elem'].length ) {
            elementary_json = data['elem'];
        }
        else {
            elementary_json = data['elementary'];
        }
        if( data['midd'].length ) {
            middle_json = data['midd'];
        }
        else {
            middle_json = data['middle'];
        }
        highschool_json = data['highschool'];
        k12_json = data['k12'];
        otherk12_json = data['otherk12'];
        publiclib_json = data['publiclib'];
        highered_json = data['highered'];
    }).done( function(){

        var all_k12_json = k12_json.concat(elementary_json).concat(middle_json)
            .concat(highschool_json).concat(otherk12_json);

        all_k12_json.sort(function(a, b) {
            if (!a.name || !b.name) return 0;
            return a.name.localeCompare(b.name);
        });

        var elementaryEntries = buildSearchIndex(elementary_json);
        var middleEntries = buildSearchIndex(middle_json);
        var highschoolEntries = buildSearchIndex(highschool_json);
        var allk12Entries = buildSearchIndex(all_k12_json);
        var k12Entries = buildSearchIndex(k12_json);
        var otherk12Entries = buildSearchIndex(otherk12_json);
        var publiclibEntries = buildSearchIndex(publiclib_json);
        var higheredEntries = buildSearchIndex(highered_json);

        var max_institution_results_all_tab = 30;
        var max_institution_results_k12_tab = 50;
        var max_institution_results_individual_tab = 200;

        initializeAccessibleAutocomplete('galileo-wayfinder-all', [
            { engine: allk12Entries, category: 'K-12', limit: max_institution_results_all_tab },
            { engine: publiclibEntries, category: 'Public Libraries', limit: max_institution_results_all_tab },
            { engine: higheredEntries, category: 'Colleges & Universities', limit: max_institution_results_all_tab }
        ], true);

        initializeAccessibleAutocomplete('galileo-wayfinder-k12', [
            { engine: elementaryEntries, category: 'Elementary Schools', limit: max_institution_results_k12_tab },
            { engine: middleEntries, category: 'Middle Schools', limit: max_institution_results_k12_tab },
            { engine: highschoolEntries, category: 'High Schools', limit: max_institution_results_k12_tab },
            { engine: otherk12Entries, category: 'Other Schools', limit: max_institution_results_k12_tab },
            { engine: k12Entries, category: 'Districts, Private K12, RESAs', limit: max_institution_results_k12_tab }
        ]);

        initializeAccessibleAutocomplete('galileo-wayfinder-publiclib', [
            { engine: publiclibEntries, category: 'Public Libraries', limit: max_institution_results_individual_tab }
        ]);

        initializeAccessibleAutocomplete('galileo-wayfinder-highered', [
            { engine: higheredEntries, category: 'Colleges & Universities', limit: max_institution_results_individual_tab }
        ]);

    });
});

/* Listener to focus on the passphrase input after clicking "Know your Password" link */
document.addEventListener('DOMContentLoaded', function () {
    console.log("Listening");
    const passphraseLink = document.getElementById('passphrase-link');
    if(passphraseLink != null){
        passphraseLink.addEventListener('click', showPassphraseInput);
    }
});
function showPassphraseInput () {
    let passphraseTextField = document.getElementById('passphrase');
    let passphraseButton = document.getElementById('passphrase-button');
    if (!passphraseTextField) {
        console.error('Passphrase input not found!');
        return;
    }

    passphraseButton.classList.remove('collapsed');
    document.getElementById('collapseOne').classList.add('show');

    passphraseTextField.style.display = "block";
    passphraseTextField.disabled = false;
    passphraseButton.style.textDecoration = 'none';
    passphraseButton.style.color = '#fff';
    passphraseButton.style.background = '#333399';
    passphraseButton.style.borderRadius = '0';
    passphraseButton.setAttribute('aria-expanded', 'true');

    // Delay to ensure rendering before focusing
    requestAnimationFrame(() => {
        passphraseTextField.focus();


    });
}

function initializeAccessibleAutocomplete(inputId, datasets, autofocus) {
    var inputElement = document.getElementById(inputId);
    if (!inputElement) return;

    var containerElement = document.createElement('div');
    containerElement.className = 'wayfinder-autocomplete flex-grow-1';
    inputElement.parentNode.replaceChild(containerElement, inputElement);

    accessibleAutocomplete({
        element: containerElement,
        id: inputElement.id,
        name: inputElement.name,
        placeholder: inputElement.getAttribute('placeholder') || '',
        defaultValue: inputElement.value || '',
        minLength: 1,
        autoselect: true,
        confirmOnBlur: false,
        displayMenu: 'overlay',
        inputClasses: 'form-control form-control-lg',
        hintClasses: 'form-control form-control-lg',
        source: function(query, populateResults) {
            var results = datasets.reduce(function(allResults, dataset) {
                return allResults.concat(
                    wayfinderResults(dataset.engine, query, dataset.category, dataset.limit)
                );
            }, []);

            populateResults(results);
        },
        templates: {
            inputValue: function(suggestion) {
                return suggestion && suggestion.name ? suggestion.name : '';
            },
            suggestion: function(suggestion) {
                var categoryHeading = suggestion.showCategoryHeader ?
                    '<span class="wayfinder-autocomplete-category">' + escapeHtml(suggestion.category) + '</span>' :
                    '';

                return categoryHeading +
                    '<span class="wayfinder-autocomplete-name">' + escapeHtml(suggestion.name) + '</span>';
            }
        },
        onConfirm: function(suggestion) {
            if (!suggestion || !suggestion.name) return;

            var renderedInput = document.getElementById(inputElement.id);
            if (renderedInput) {
                renderedInput.value = suggestion.name;
            }
            $(containerElement).closest('form').submit();
        }
    });

    var renderedInput = document.getElementById(inputElement.id);
    if (autofocus && renderedInput) {
        renderedInput.focus();
    }
}

function buildSearchIndex(entries) {
    return entries.map(function(entry) {
        return $.extend({}, entry, {
            tokens: wayfinderTokens(entry).map(function(token) {
                return token.toLowerCase();
            })
        });
    });
}

function wayfinderResults(entries, query, category, limit) {
    var queryTokens = nonwordTokens(query).map(function(token) {
        return token.toLowerCase();
    });

    if (!queryTokens.length) return [];

    return entries.filter(function(entry) {
        return queryTokens.every(function(queryToken) {
            return entry.tokens.some(function(entryToken) {
                return entryToken.indexOf(queryToken) === 0;
            });
        });
    }).slice(0, limit).map(function(entry, index) {
        return $.extend({}, entry, {
            category: category,
            showCategoryHeader: index === 0
        });
    });
}

function wayfinderTokens(datum) {
    var allTokens = nonwordTokens(datum.name).concat(nonwordTokens(datum.code));
    if(datum.keywords) {
        allTokens = allTokens.concat(nonwordTokens(datum.keywords));
    }

    return allTokens;
}

function nonwordTokens(value) {
    return String(value || '').split(/\W+/).filter(function(token) {
        return token;
    });
}

function escapeHtml(value) {
    var escapeMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };

    return String(value || '').replace(/[&<>"']/g, function(character) {
        return escapeMap[character];
    });
}
